import script from "./MonitorPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonitorPage.vue?vue&type=script&setup=true&lang=ts"

import "./MonitorPage.vue?vue&type=style&index=0&id=b4921bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4921bfe"]])

export default __exports__